import GameInfoSection from "./GameInfoSections";
import ImageStorage from "../../utils/ImageStorage";
import NewsSection from "./NewsSection";
import CharactersSection from "./CharactersSection";
import PromotionsSection from "./PromotionsSection";
import UserFeedbackSection from "./UserFeedbackSection";
import { getMobileOperatingSystem } from "../../utils/DeviceUtils";

const isIOS = getMobileOperatingSystem() === "ios";

const HomePage = () => {
  return (
    <>
      <div className="home-background">
        <div className="home-banner">
          <div className="home-banner-pattern">
            <div className="home-logo-mobile"></div>
            <div className="home-text">
              <img
                src={ImageStorage.HomeText}
                alt="Lựa Chọn Vận Mệnh - Chinh Phục Mỹ Nhân"
              />
            </div>

            <div className="section-banner-group hidden lg:block">
              <img src={ImageStorage.HomeCTABackground} />
              <div>
                <a
                  href="/play-game?utm_source=Website&utm_medium=Homepage-tlvlg&utm_campaign=BR-PN-0000-MF-AR-280522-1000-KP-TQ-BN-ZG-RTS752-button-choingay"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={ImageStorage.HomeCTAPlay} />
                </a>
                <div>
                  <a
                    href="https://play.google.com/store/apps/details?id=zagoo.game.vlg"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img src={ImageStorage.HomeCTAGoogle} />
                  </a>
                  <a
                    href="https://h5.zadn.vn/games/vlg/Packages/zagoo.game.vlg-release-v1.0-12-2023-02-13.apk"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img src={ImageStorage.HomeCTAApk} />
                  </a>
                </div>
                <a
                  href="https://pay.zing.vn/zalo/products/vlg"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img src={ImageStorage.HomeCTATopup} />
                </a>
              </div>
            </div>
            {isIOS ? (
              <a
                className="home-button-mobile"
                href="/play-game?utm_source=Website&utm_medium=Homepage-tlvlg&utm_campaign=BR-PN-0000-MF-AR-280522-1000-KP-TQ-BN-ZG-RTS752-button-choingay"
                target="_blank"
                rel="noreferrer"
              ></a>
            ) : (
              <a
                className="home-button-mobile background-none"
                href="https://play.google.com/store/apps/details?id=zagoo.game.vlg"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  className="mobile-download-ggplay  block lg:hidden"
                  src={ImageStorage.FloatingGooglePlay}
                />
              </a>
            )}
          </div>
        </div>
        <GameInfoSection />
        <NewsSection />
        <CharactersSection />
        <PromotionsSection />
        <UserFeedbackSection />
      </div>
    </>
  );
};

export default HomePage;
